import { filter, mapTo } from "rxjs/operators";
import { TypeActionModal } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionGameTrackingUpdateShop } from "../../actionGameTracking";
import { IdGameTrackingShopState } from "../IdGameTrackingShopState";
export var epicGameTrackingShopQuit = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionModal.Close && action.modalId === IdModal.Shop;
    }), mapTo(actionGameTrackingUpdateShop(IdGameTrackingShopState.SHOP_QUIT)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/shop/epics/epicGameTrackingShopQuit.ts
// module id = 1884
// module chunks = 3